import moment from 'moment';

import { LONG_DATE_ONLY_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import {
  DEADLINE_TYPES,
  type getDeadlineCopyForDegreeCard,
} from 'bundles/unified-common/utils/getDeadlineCopyForDegreeCard';

type ProgramAdmissionDeadlines = Array<{
  priorityDeadlineDate?: string | null;
  secondaryPriorityDeadlineDate?: string | null;
  subtermDeadlineDate?: string | null;
  extendedSubtermDeadlineDate?: string | null;
}>;
type DeadlineType = keyof typeof DEADLINE_TYPES;

const updateNextDeadline = (
  nextDeadlineDate: moment.Moment | undefined,
  currentDateValue: moment.Moment | null
): moment.Moment | undefined => {
  const now = moment();
  if (currentDateValue !== null && now.isBefore(currentDateValue)) {
    return !nextDeadlineDate ? currentDateValue : moment.min(nextDeadlineDate, currentDateValue);
  }
  return nextDeadlineDate;
};

export const getDeadlineCopyForHubPage = (
  programAdmissionDeadlines: ProgramAdmissionDeadlines | undefined,
  customGetCopy: (datelineType: DeadlineType, date: string | null) => ReturnType<typeof getDeadlineCopyForDegreeCard>
): ReturnType<typeof getDeadlineCopyForDegreeCard> => {
  if (programAdmissionDeadlines && programAdmissionDeadlines.length > 0) {
    // match the logic on BE, pick the min date of the priority, secondary priority, subterm, extended subterm
    let nextDt;
    for (const current of programAdmissionDeadlines) {
      nextDt = updateNextDeadline(nextDt, moment(current.priorityDeadlineDate));
      nextDt = updateNextDeadline(nextDt, moment(current.secondaryPriorityDeadlineDate));
      nextDt = updateNextDeadline(nextDt, moment(current.subtermDeadlineDate));
      nextDt = updateNextDeadline(nextDt, moment(current.extendedSubtermDeadlineDate));
    }

    if (nextDt) {
      return customGetCopy(DEADLINE_TYPES.priorityDeadline, formatDateTimeDisplay(nextDt, LONG_DATE_ONLY_DISPLAY));
    }
  }
  // no deadline
  return { body: '' };
};
